<script setup>
import { VueFinalModal } from "vue-final-modal";
import { ref } from "vue";

const props = defineProps({
    phone: String,
    phoneto: String,
    title: { type: String, default: "Мина и партнёры" },
    subtitle: { type: String, default: "Юридическая помощь" },
});

const called = ref(false);
const emit = defineEmits(['close']);
</script>

<template>
    <VueFinalModal
        class="flex items-end sm:items-center justify-center"
        content-class="relative w-full sm:max-w-sm bg-white rounded-t-3xl sm:rounded-2xl shadow-xl p-6"
    >
        <button type="button" @click="emit('close')"
            class="absolute top-4 right-4 text-gray-500 hover:text-gray-600 transition-colors">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
        </button>

        <!-- Brand -->
        <div class="text-center mb-5">
            <p class="text-lg font-bold text-gray-900">{{ props.title }}</p>
            <p class="text-sm text-gray-500">{{ props.subtitle }}</p>
        </div>

        <!-- Trust signals -->
        <ul class="flex flex-col gap-2 mb-5">
            <li class="flex items-center gap-2 text-sm text-gray-700">
                <svg class="w-4 h-4 text-green-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                Первая консультация — <strong class="ml-1">бесплатно</strong>
            </li>
            <li class="flex items-center gap-2 text-sm text-gray-700">
                <svg class="w-4 h-4 text-green-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                Без выходных, <strong class="ml-1">с 9:00 до 21:00</strong>
            </li>
            <li class="flex items-center gap-2 text-sm text-gray-700">
                <svg class="w-4 h-4 text-green-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                Более <strong class="mx-1">15 лет</strong> юридической практики
            </li>
        </ul>

        <!-- Phone -->
        <a :href="props.phoneto"
            class="flex items-center justify-center gap-2 text-xl font-bold text-blue-700 hover:text-blue-900 mb-5 py-3 bg-blue-50 rounded-xl transition-colors">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
            </svg>
            {{ props.phone }}
        </a>

        <!-- Survey -->
        <template v-if="!called">
            <p class="text-center text-sm font-medium text-gray-700 mb-3">Вам удалось дозвониться?</p>
            <div class="flex gap-3">
                <button
                    onclick="window.goal('PHONE_BTN');"
                    @click="emit('close')"
                    class="flex-1 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors">
                    Да
                </button>
                <button
                    @click="called = true"
                    class="flex-1 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-semibold rounded-lg transition-colors">
                    Нет
                </button>
            </div>
        </template>

        <template v-else>
            <p class="text-center text-sm font-medium text-gray-700 mb-3">Сохраните номер, чтобы не искать</p>
            <button @click="emit('close')"
                class="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors">
                Хорошо, спасибо
            </button>
        </template>
    </VueFinalModal>
</template>
